import { energyConstants } from "../_constants";
import { energyService } from "../_services";
import { alertActions } from "./";
//import { history } from '../_helpers';

export const energyActions = {
  getTodayStatus,
  getDailyStatus,
  getUsedAppliances,
  getDetail,
  setUsageFrequency,
  setDetailItem,
  toggleExpander,
  getTimeline
};

function getTimeline(user, timestamp) {
  return dispatch => {
    dispatch(request());

    energyService.getTimeline(user, timestamp).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: energyConstants.TIMELINE_REQUEST };
  }
  function success(detail) {
    return { type: energyConstants.TIMELINE_SUCCESS, detail };
  }
  function failure(error) {
    return { type: energyConstants.TIMELINE_FAILURE, error };
  }
}

function getTodayStatus(user, timestamp) {
  return dispatch => {
    dispatch(request());

    energyService.getTodayStatus(user, timestamp).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: energyConstants.TODAY_STATUS_REQUEST };
  }
  function success(detail) {
    return { type: energyConstants.TODAY_STATUS_SUCCESS, detail };
  }
  function failure(error) {
    return { type: energyConstants.TODAY_STATUS_FAILURE, error };
  }
}

function getDailyStatus(user, timescale, timestamp) {
  return dispatch => {
    dispatch(request());

    energyService.getDailyStatus(user, timescale, timestamp).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: energyConstants.DAILY_STATUS_REQUEST };
  }
  function success(detail) {
    return { type: energyConstants.DAILY_STATUS_SUCCESS, detail };
  }
  function failure(error) {
    return { type: energyConstants.DAILY_STATUS_FAILURE, error };
  }
}

function getUsedAppliances() {
  return dispatch => {
    dispatch(request());

    energyService.getUsedAppliances().then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: energyConstants.USED_REQUEST };
  }
  function success(detail) {
    return { type: energyConstants.USED_SUCCESS, detail };
  }
  function failure(error) {
    return { type: energyConstants.USED_FAILURE, error };
  }
}

function getDetail(user, timescale, timestamp) {
  return dispatch => {
    dispatch(request());

    energyService.getDetail(user, timescale, timestamp).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: energyConstants.DETAIL_REQUEST };
  }
  function success(detail) {
    return { type: energyConstants.DETAIL_SUCCESS, detail };
  }
  function failure(error) {
    return { type: energyConstants.DETAIL_FAILURE, error };
  }
}

function setUsageFrequency(timescale) {
  return dispatch => {
    dispatch(setFrequency(timescale));
  };

  function setFrequency(timescale) {
    return { type: energyConstants.SET_USAGE_FREQUENCY, timescale };
  }
}

function setDetailItem(item) {
  return dispatch => {
    dispatch(setItem(item));
  };

  function setItem(item) {
    return { type: energyConstants.SET_DETAIL_ITEM, item };
  }
}

function toggleExpander() {
  return dispatch => {
    dispatch(toggle());
  };

  function toggle() {
    return { type: energyConstants.TOGGLE_EXPANDER };
  }
}
